import React from 'react';
import { Select as AntSelect } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

export const Select = ({ 
  label,
  labelHelpText,
  error,
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  options = [], 
  value,
  onChange,
  onSearch,
  mode,
  minWidth = mode === 'multiple' || mode === 'tags' ? 200 : undefined,
  ...props 
}) => {
  return (
    <InputWrapper
      label={label}
      labelHelpText={labelHelpText}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AntSelect
        status={error ? 'error' : ''}
        options={options}
        value={value}
        onChange={onChange}
        onSearch={onSearch}
        mode={mode}
        style={{ 
          minWidth,
          width: '100%',
          ...props.style 
        }}
        {...props}
      />
    </InputWrapper>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.any,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  mode: PropTypes.oneOf(['multiple', 'tags']),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Select; 